import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useExampleStore } from './_store'

export const Example: React.FC = () => {
    const { count, dispatch } = useExampleStore()

    const handleClick = () => {
        dispatch({
            type: 'increment',
            amount: 50,
        })
    }

    return (
        <Box>
            <Typography>
                count:
                {count}
            </Typography>
            <Button onClick={handleClick}>Update count</Button>
        </Box>
    )
}
